/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RoleDto } from '../models/role-dto';

@Injectable({
  providedIn: 'root',
})
export class ProjectRoleRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getProjectRoles
   */
  static readonly GetProjectRolesPath = '/api/v1/projectroles';

  /**
   * Provides the list of all project role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectRoles$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRoleRestControllerService.GetProjectRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleDto>>;
      })
    );
  }

  /**
   * Provides the list of all project role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectRoles(params?: {
  },
  context?: HttpContext

): Observable<Array<RoleDto>> {

    return this.getProjectRoles$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleDto>>) => r.body as Array<RoleDto>)
    );
  }

  /**
   * Path part for operation getProjectRoleById
   */
  static readonly GetProjectRoleByIdPath = '/api/v1/projectroles/{id}';

  /**
   * Provides RoleDto based on given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectRoleById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectRoleById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRoleRestControllerService.GetProjectRoleByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Provides RoleDto based on given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProjectRoleById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectRoleById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<RoleDto> {

    return this.getProjectRoleById$Response(params,context).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation deleteProjectRole
   */
  static readonly DeleteProjectRolePath = '/api/v1/projectroles/{projectId}';

  /**
   * Removes Role passed to the method from Projects based on the given projectId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProjectRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProjectRole$Response(params: {
    projectId: number;
    body: RoleDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectRoleRestControllerService.DeleteProjectRolePath, 'delete');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Role passed to the method from Projects based on the given projectId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProjectRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProjectRole(params: {
    projectId: number;
    body: RoleDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteProjectRole$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
